
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commercial-storage-near-me",
      function () {
        return require("private-next-pages/commercial-storage-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commercial-storage-near-me"])
      });
    }
  